import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { supabase } from "../lib/supabase";
import Carousel from "../components/Carousel";
import Navbar from "../components/Navbar";
import Buttons from "../components/Buttons";
import "./SelectChampion.css";

export default function SelectChampion() {
  const [name, setName] = useState("Paolo");
  const [selectedChampion, setSelectedChampion] = useState<string | null>(null);
  const [isUpdating, setIsUpdating] = useState(false);
  const navigate = useNavigate();
  const { user, loading } = useAuth();

  useEffect(() => {
    if (loading) return;

    if (!user) {
      navigate("/login");
      return;
    }

    if (user.user_metadata?.full_name) {
      const firstName = user.user_metadata.full_name.split(" ")[0];
      setName(firstName);
    } else if (user.email) {
      const firstName = user.email.split("@")[0];
      setName(firstName);
    }

    const savedChampion = localStorage.getItem("selectedChampion");
    if (savedChampion) {
      setSelectedChampion(savedChampion);
    }
  }, [user, navigate, loading]);

  const handleSbircialoClick = () => {
    navigate("/ranking");
  };

  const handleGioca = async () => {
    if (isUpdating) return;

    setIsUpdating(true);

    try {
      if (user?.id && selectedChampion) {
        const { error } = await supabase
          .from("game_scores")
          .update({ personaggio_selezionato: parseInt(selectedChampion) })
          .eq("user_id", user.id);

        if (error) {
          console.error("Errore aggiornamento personaggio:", error);
        }
      }

      const playerName = name;
      const championId = selectedChampion || "";
      const playerEmail = user?.email || "";
      const userId = user?.id || "";

      sessionStorage.setItem("playerName", playerName);
      sessionStorage.setItem("selectedChampion", championId);
      sessionStorage.setItem("playerEmail", playerEmail);
      sessionStorage.setItem("userId", userId);

      localStorage.setItem("playerName", playerName);
      localStorage.setItem("selectedChampion", championId);
      localStorage.setItem("playerEmail", playerEmail);
      localStorage.setItem("userId", userId);

      navigate("/game");
    } catch (err) {
      console.error("Errore durante il salvataggio:", err);
      setIsUpdating(false);
    }
  };

  const handleChampionSelect = (championId: string) => {
    setSelectedChampion(championId);
  };

  if (loading) {
    return (
      <div className="select-container">
        <Navbar />
        <div className="title color-gradient">
          <h2>Caricamento...</h2>
        </div>
      </div>
    );
  }

  return (
    <div className="select-container">
      <Navbar />

      <div className="title color-gradient">
        <h2>Ci siamo quasi, {name}...</h2>
      </div>

      <div className="subtitle color-gradient">
        <p>
          <b>Scegli</b> il tuo giocatore!
        </p>
      </div>

      <Carousel onSelect={handleChampionSelect} />

      <Buttons
        onClickFirst={handleGioca}
        onClickSecond={handleSbircialoClick}
        textFirst={isUpdating ? "CARICAMENTO..." : "GIOCA ORA!"}
        textSecond="SBIRCIA I PUNTEGGI"
      />
    </div>
  );
}
